// Every destination the chrome and the home-page sections link to.
//
// These were collapsed to home-page anchors while this repo held only the
// landing page. The rest of the site lives here now, so anything with a real
// page points at it again; what is left as an "#id" is genuinely a section of
// the home page with no page of its own.
export const S = {
  // Pages
  services: "/services/",
  ai: "/services/ai/",
  digitalProductSystem: "/services/digital-product-system-development/",
  mvp: "/services/mvp/",
  web: "/services/web-system-app-development/",
  website: "/services/website/",
  companyGpt: "/products/company-gpt/",
  products: "/products/",
  smartpost: "/products/smartpost-ai/",
  nextCx: "/products/next-cx-ai/",
  talentcloud: "/products/talentcloud/",
  nextWorkforce: "/products/next-workforce/",
  works: "/works/",
  about: "/about/",
  members: "/members/",
  insights: "/insights/",
  news: "/news/",
  faq: "/faq/",
  contact: "/contact/",

  // Home-page sections. `/myanmar-market-support` and the AI-marketing and
  // workforce offerings have no page; the home page is where they are covered.
  aiMarketing: "#ai-marketing",
  workforce: "#workforce",
  marketSupport: "#myanmar-market-support",
  howWeStart: "#how-we-start",
  strength: "#strength",
  previews: "#previews",   // also where the members strip lives
  tiktok: "#tiktok",
  nextStep: "#next-step",
};

// Nav and footer render on every page, where an "#id" scrolls nowhere. Resolve
// those against the home page; leave real paths alone.
export const anchor = (href) =>
  (href.startsWith("#") && (window.PAGE || "home") !== "home" ? `/${href}` : href);

// Contact has a page again, so its links keep a real href — but the in-app
// consultation panel is still the better answer when JS is running.
export const openConsult = (detail) => (event) => {
  event.preventDefault();
  window.dispatchEvent(new CustomEvent("nx:consult:open", detail ? { detail } : undefined));
};
